// Phase JB.3c — useWorldCup hook.
//
// Anon-readable. Returns the next 5 upcoming world_cup_table rows
// where kickoff_at >= now(), ordered ascending. Public read is allowed
// by the JB.3a RLS policy "world_cup_anon read all".

import { useEffect, useState } from "react";
import { getBrowserClient } from "../supabase/browser.ts";

export interface WorldCupMatch {
  match_id: string;
  group_or_stage: string;
  home_team: string;
  away_team: string;
  kickoff_at: string;
  status: "placeholder" | "scheduled" | "live" | "settled" | "cancelled";
}

export interface UseWorldCupResult {
  matches: WorldCupMatch[];
  loading: boolean;
  error: string | null;
}

export function useWorldCup(): UseWorldCupResult {
  const [matches, setMatches] = useState<WorldCupMatch[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const sb = getBrowserClient();
    const nowIso = new Date().toISOString();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (sb.from("world_cup_table" as never) as any)
      .select("match_id,group_or_stage,home_team,away_team,kickoff_at,status")
      .gte("kickoff_at", nowIso)
      .order("kickoff_at", { ascending: true })
      .limit(5)
      .then((res: { data: WorldCupMatch[] | null; error: { message: string } | null }) => {
        if (cancelled) return;
        if (res.error) setError(res.error.message);
        else setMatches(res.data ?? []);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { matches, loading, error };
}
